import { useEffect, useState } from "react";
import {
  getDispatchListService,
  returnOrderService,
} from "../../../services/apiService";
import ReactDOM from "react-dom";

const DisplayDispatch = () => {
  const [dispatchOrders, setDispatchOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [reason, setReason] = useState("");

  const fetchDispatchOrders = async () => {
    try {
      const res = await getDispatchListService();
      setDispatchOrders(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDispatchOrders();
  }, []);

  const filteredOrders = dispatchOrders.filter((o) =>
    o.orderid.toLowerCase().includes(search.toLowerCase()),
  );

  const totalPages = Math.ceil(filteredOrders.length / pageSize);
  const paginatedData = filteredOrders.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );

  // 🔁 Submit Return Order
  const handleReturnSubmit = async () => {
    try {
      await returnOrderService({
        orderid: selectedOrderId,
        desc: reason,
      });

      alert("Return request submitted successfully!");
      setShowModal(false);
      setReason("");
      fetchDispatchOrders();
    } catch (err) {
      alert("Failed to submit return request");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ color: "#005487" }}>Dispatch Orders</h3>

      <input
        placeholder="Search by Order ID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ padding: "8px", marginBottom: "10px", width: "250px" }}
      />

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f2f2f2" }}>
            <th style={th}>Order ID</th>
            <th style={th}>Order Date</th>
            <th style={th}>Net Amount</th>
            <th style={th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item) => (
            <tr key={item.id}>
              <td style={td}>{item.orderid}</td>
              <td style={td}>
                {new Date(item.orderdate).toLocaleDateString()}
              </td>
              <td style={td}>₹ {Number(item?.netamount || 0).toFixed(2)}</td>
              <td style={td}>
                <button
                  style={returnBtn}
                  onClick={() => {
                    setSelectedOrderId(item.orderid);
                    setShowModal(true);
                  }}
                >
                  Return Order
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}

      <div className="pagination-container">
        <div>
          Items per page:
          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="page-buttons">
          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>

          <span className="page-count">
            {page} / {totalPages || 1}
          </span>

          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      {/* 🔥 Return Modal */}
      {showModal &&
        ReactDOM.createPortal(
          <div style={modalOverlay}>
            <div style={modalBox}>
              <h3>Return Order</h3>

              <p>
                <b>Order ID:</b> {selectedOrderId}
              </p>

              <textarea
                placeholder="Enter return reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                style={textarea}
              />

              <div style={{ textAlign: "right" }}>
                <button onClick={() => setShowModal(false)} style={cancelBtn}>
                  Cancel
                </button>
                <button onClick={handleReturnSubmit} style={submitBtn}>
                  Submit
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

/* ===== Styles ===== */
const th = { padding: "10px", border: "1px solid #ddd" };
const td = { padding: "10px", border: "1px solid #ddd" };

const returnBtn = {
  background: "#ff4d4f",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "4px",
  cursor: "pointer",
};

const paginationStyle = {
  marginTop: "15px",
  display: "flex",
  justifyContent: "space-between",
};

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalBox = {
  background: "#fff",
  padding: "20px",
  width: "400px",
  borderRadius: "6px",
};

const textarea = {
  width: "100%",
  minHeight: "80px",
  marginBottom: "10px",
};

const cancelBtn = {
  marginRight: "10px",
  padding: "6px 12px",
  borderRadius: "8px",
};

const submitBtn = {
  background: "#005487",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "8px",
};

export default DisplayDispatch;
